<template>
    <div>
        <el-row :gutter="10" style="z-index: 0">
        <el-col>
            <el-tabs type="border-card" v-model="activeTab" @tab-click="tabClick">
                <el-tab-pane label="Index" name="index">
                     <div class="toolbar">
                    <el-row>
                        <el-col :span="24" :md="24" :sm="24" :xs="24" justify="end">
                            <template>
                                <el-select v-model="selectedMessageTypeField" placeholder="Message Type" style="width:130px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                    <el-option
                                    v-for="item in messageTypeField"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                
                                <el-select v-model="selectedFilter" placeholder="Filter By" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                    <el-option
                                    v-for="itm in filterBy"
                                    :key="itm.value"
                                    :label="itm.label"
                                    :value="itm.value">
                                    </el-option>
                                </el-select>
                                <el-select v-model="selectedField" placeholder="Select Field" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                    <el-option
                                    v-for="item in searchFields"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <el-date-picker class="mr-5 mb-10"
                                    style="top: 2px !important; width:220px;"
                                    v-model="selectedStartDate"
                                    :picker-options="pickerOptions"
                                    range-separator="to"
                                    size="mini"
                                    type="daterange"
                                    placeholder="Pick a day">
                                </el-date-picker>
                                <el-button-group class="mr-10 ml-10">
                                    <el-button type="primary" round size="mini" :loading="loadingReportTable" class="animated fadeInRight" style="background-color: #0047FF;" @click="changeFilter">
                                        Set Filter
                                    </el-button>
                                </el-button-group>
                            </template>
                        </el-col>
                    </el-row>
                </div>
                <br>
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <!-- <div>
                            <span>Send : </span><span>Delivered : </span><span>Read : </span>
                        </div> -->
                        <el-row class="mb-10" style="font-size:14px;">
                            <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable">
                                <el-card style="background-color:#5EA369; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px;" class="mb-10">
                                    <span style="font-size:14px;">DKD | Meta Active WABA (Clients) </span><br>
                                    <span style="font-size:16px;">
                                        {{dataTwentySummary.waba_active || 0}} | 
                                        <br>
                                        {{dataTwentySummary.waba_active || 0}}
                                    </span>
        
                                </el-card>
                            </el-col>
                            <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable">
                                <el-card style="background-color:#8CBC26; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px;" class="mb-10">
                                    <span style="font-size:14px;">DKD | Meta Active Phone Number </span><br>
                                    <span style="font-size:16px;">
                                        {{dataTwentySummary.number_active || 0}} | 
                                        <br>
                                        {{dataTwentySummary.number_active || 0}}
                                    </span>
        
                                </el-card>
                            </el-col>
                            <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable">
                                <el-card style="background-color:#5EA369; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px;" class="mb-10">
                                    <span style="font-size:14px;">DKD | Meta Total BI </span><br>
                                    <span style="font-size:16px;">
                                        {{dataTwentySummary.dkd_bi || 0}} | 
                                        <br>
                                        {{dataTwentySummary.meta_bi || 0}}
                                    </span>
        
                                </el-card>
                            </el-col>
                            <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable">
                                <el-card style="background-color:#8CBC26; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px;" class="mb-10">
                                    <span style="font-size:14px;">DKD Total CBP (BI|UI) </span><br>
                                    <span style="font-size:16px;">
                                        {{(dataTwentySummary.dkd_bi|| 0)}} | 
                                        <br>
                                        {{(dataTwentySummary.dkd_ui || 0)}}
                                    </span>
        
                                </el-card>
                            </el-col>
                            <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable">
                                <el-card style="background-color:#5EA369; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px;" class="mb-10">
                                    <span style="font-size:14px;">DKD | Meta Revenue </span><br>
                                    <span style="font-size:16px;">
                                        {{ formatPrice(dataTwentySummary.dkd_revenue || 0) }} | 
                                        <br>
                                        {{ formatPrice(dataTwentySummary.meta_revenue|| 0)}}
                                    </span>
        
                                </el-card>
                            </el-col>
                        </el-row>
                        <el-row style="font-size:14px;">
                            <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable">
                                <el-card style="background-color:#7CC97F; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px;" class="mb-10">
                                    <span style="font-size:14px;">DKD | Meta Pasive WABA (Clients) </span><br>
                                    <span style="font-size:16px;">
                                        {{ dataTwentySummary.dkd_waba_passive || 0}} | 
                                        <br>
                                        {{ dataTwentySummary.waba_passive || 0}}
                                    </span>
        
                                </el-card>
                            </el-col>
                            <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable">
                                <el-card style="background-color:#BAED67; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px;" class="mb-10">
                                    <span style="font-size:14px;">DKD | Meta Pasive Phone Number </span><br>
                                    <span style="font-size:16px;">
                                        {{ dataTwentySummary.dkd_phone_number_passive || 0}} | 
                                        <br>
                                        {{ dataTwentySummary.phone_number_passive || 0}}
                                    </span>
        
                                </el-card>
                            </el-col>
                            <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable">
                                <el-card style="background-color:#7CC97F; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px;" class="mb-10">
                                    <span style="font-size:14px;">DKD | Meta Total UI </span><br>
                                    <span style="font-size:16px;">
                                        {{dataTwentySummary.dkd_ui || 0}} | 
                                        <br>
                                        {{dataTwentySummary.meta_ui || 0}}
                                    </span>
        
                                </el-card>
                            </el-col>
                            <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable">
                                <el-card style="background-color:#BAED67; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px;" class="mb-10">
                                    <span style="font-size:14px;">DKD | Meta Total BI+UI (Inc. CBP) </span><br>
                                    <span style="font-size:16px;">
                                        {{dataTwentySummary.dkd_total || 0}} | 
                                        <br>
                                        {{dataTwentySummary.meta_total || 0}}
                                    </span>
        
                                </el-card>
                            </el-col>
                            <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable">
                                <el-card style="background-color:#7CC97F; font-size:12px; color:#ffffff; font-weight:bold; min-height:125px;" class="mb-10">
                                    <span style="font-size:14px;">Total not set WABA ID | Numbers </span><br>
                                    <span style="font-size:16px;">
                                        {{dataTwentySummary.waba_not_set || 0}} | 
                                        <br>
                                        {{dataTwentySummary.phone_number_not_set || 0}}
                                    </span>
        
                                </el-card>
                            </el-col>
                        </el-row>
                        <el-row class="mb-10">
                            <el-col>
                                <el-card style="background-color:#FFEFB8; font-size:12px; color:#ffffff; font-weight:bold;" shadow="never">
                                    <span style="color:black;">Informasi: Data Facebook diambil oleh Cron (Auto by system) dan data di atas adalah berdasarkan total data top 20 client</span>
                                </el-card>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col>
                                <el-card shadow="card-shadow--small">
                                    <!-- <el-pagination
                                        background
                                        prev-text="Prev"
                                        next-text="Next"
                                        layout="prev, pager, next"
                                        :page-size="50"
                                        @current-change="paginateReport"
                                        :current-page="currentPage"
                                        :total="totalMessages">
                                    </el-pagination><br> -->
                                    <div class="group-list scrollable only-y">
                                        <template>
                                             <div>
                                                <span style="color:black;">Top 20 Client from META</span>
                                             </div>
                                             <el-table
                                                v-loading="loadingReportTable"
                                                :data="tableData"
                                                :span-method="objectSpanMethod"
                                                style="width: 100%; margin-top: 20px">
                                                <el-table-column
                                                    prop="no"
                                                    label="No"
                                                    width="70">
                                                </el-table-column>
                                                <el-table-column
                                                    prop="id"
                                                    label="WABA ID"
                                                    width="150">
                                                </el-table-column>
                                                <el-table-column
                                                    prop="name"
                                                    label="WABA Name"
                                                    width="220">
                                                </el-table-column>
                                                <el-table-column
                                                    v-if="ui_phone"
                                                    prop="phone_number"
                                                    label="Phone Number"
                                                    width="150">
                                                </el-table-column>
                                                <el-table-column
                                                    prop="type"
                                                    label="Type">
                                                </el-table-column>
                                                <el-table-column
                                                    prop="case"
                                                    label="Case"
                                                    width="250">
                                                </el-table-column>
                                                <el-table-column
                                                    prop="session"
                                                    label="Session"
                                                    width="100">
                                                </el-table-column>
                                                <el-table-column
                                                    prop="revenue"
                                                    label="Revenue"
                                                    width="200"
                                                    header-align="center">
                                                    <template slot-scope="props">
                                                        <div style="float: right;">
                                                            <p style="font-weight:bold;">{{ !props.row.revenue ? '-':formatPrice(props.row.revenue)}}</p>
                                                        </div>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                    fixed="right"
                                                    label="Action"
                                                    width="100">
                                                    <template slot-scope="scope">
                                                        <el-button v-if="!ui_phone" size="small" @click="detailTopTwenty(scope.row)">Detail</el-button>
                                                        <!-- <div style="text-align: center;" v-else>-</div> -->
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </template>
                                    </div><br/>
                                    <!-- <el-pagination
                                        background
                                        prev-text="Prev"
                                        next-text="Next"
                                        layout="prev, pager, next"
                                        :page-size="50"
                                        @current-change="paginateReport"
                                        :current-page="currentPage"
                                        :total="totalMessages">
                                    </el-pagination> -->
                                </el-card>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
                </el-tab-pane>	  
                <el-tab-pane label="Compare" name="Compare">
                    <el-row>
                        <el-col :span="24" :md="24" :sm="24" :xs="24" justify="end">
                            <template>
                                <el-select v-model="selectedTypeField" placeholder="Type" style="width:14%;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                    <el-option
                                    v-for="item in typeField"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                
                                <el-select @change="handleChangeCompare" v-model="filterChart2" placeholder="Filter By" style="width:16%;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                    <el-option
                                    v-for="itm in filterByCompare"
                                    :key="itm.value"
                                    :label="itm.label"
                                    :value="itm.value">
                                    </el-option>
                                </el-select>
                                <el-select v-model="selectedFieldCompare" placeholder="Select Field" style="width:15%;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                    <el-option
                                    v-for="item in messageTypeField"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-row>
                                <el-col :span="10">
                                    <el-date-picker class="mr-5 mb-10"
                                        style="top: 2px !important; width:100%;"
                                        v-model="selectedStartDate1"
                                        range-separator="to"
                                        size="mini"
                                        type="daterange"
                                        placeholder="Pick a day">
                                    </el-date-picker>
                                    <el-input
                                        size="small"
                                        :placeholder="selectedFieldCompare == 'waba' ? `Input Waba Id`: `Input Phone Number (62)`"
                                        v-model="input1">
                                    </el-input>
                                </el-col>
                                <el-col style="text-align:center; padding-top: 40px;" :span="2">
                                    <span style="">vs</span>
                                </el-col>
                                <el-col :span="10">
                                    <el-date-picker v-if="filterChart2 == 'date'" class="mr-5 mb-10"
                                        style="top: 2px !important; width:100%;"
                                        v-model="selectedStartDate2"
                                        range-separator="to"
                                        size="mini"
                                        type="daterange"
                                        placeholder="Pick a day">
                                    </el-date-picker>
                                    <div v-else style="height:38px;"></div>
                                    <el-input
                                        size="small"
                                        :placeholder="selectedFieldCompare == 'waba' ? `Input Waba Id`: `Input Phone Number (62)`"
                                        v-model="input2">
                                    </el-input>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-button-group class="mr-10 mt-10">
                                <el-button type="primary" round size="mini" :loading="loadingReportTable" class="animated fadeInRight" style="background-color: #0047FF;" @click="changeFilterCompare">
                                    Set Filter
                                </el-button>
                            </el-button-group>
                        </el-col>
                    </el-row>
                    <el-row v-if="!dataChart1.loading">
                        <el-col>
                            <ChartOne v-if="!dataChart1.loading" id="chart-1" :type="'line'" :data="dataChart1" :options="options"></ChartOne>
                        </el-col>
                    </el-row>
                    <el-row v-else v-loading="dataChart1.loading">
                        <el-col style="min-height: 503px;"></el-col>
                    </el-row>
                    <el-row v-if="filterChart2 == 'date' && !dataChart2.loading">
                        <el-col>
                            <ChartTwo v-if="!dataChart2.loading" id="chart-2" :type="'line'" :data="dataChart2" :options="options"></ChartTwo>
                        </el-col>
                    </el-row>
                    <el-row v-else v-loading="dataChart2.loading">
                        <el-col style="min-height: 503px;"></el-col>
                    </el-row>
                </el-tab-pane>
            </el-tabs>
        </el-col>
        </el-row>
        <!-- <el-alert title="Info" type="info" :closable="false" description="No Data" show-icon v-else></el-alert> -->
        <el-dialog :close-on-click-modal="false" :title="`WABA ID : ${idDetail}`" :visible.sync="modalDetail" style="width: 100%;">
		<template>

			<!-- <el-select style="width: 40%;" v-model="phoneNumberSessionSelected" @change="handleChangeSelectedSession" filterable placeholder="Select Country">
				<el-option
				v-for="(item,i) in phoneNumberSession" :key="i"
				:label="`+${item.label}`"
				:value="item.value">
				</el-option>
			</el-select> -->
			<div style="margin: 30px 0;"></div>
            <el-table
                :data="dataDetail"
                v-loading="loadingDetail"
                :span-method="objectSpanMethodDetail"
                style="width: 100%;">
                <el-table-column
                    prop="phone_number"
                    label="Phone Number">
                    <template slot-scope="props">
                        <p>{{ '+' + props.row.phone_number}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="masking_name"
                    label="Masking Name">
                </el-table-column>
                <el-table-column
                    prop="type"
                    label="Type"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="case"
                    label="Case"
                    width="250">
                </el-table-column>
                <el-table-column
                    prop="session"
                    label="Session">
                </el-table-column>
                <el-table-column
                    prop="revenue"
                    label="Revenue">
                    <template slot-scope="props">
                        <p style="font-weight:bold;">{{!props.row.revenue ?'-':formatPrice(props.row.revenue)}}</p>
                    </template>
                </el-table-column>
            </el-table>
		</template>
	</el-dialog>
    </div>
</template>
<script>
import api from '@/networkClient'
import config from '@/config'
import ChartOne from 'vue-bulma-chartjs'
import ChartTwo from 'vue-bulma-chartjs'
const moment = require('moment')
export default {
    name: 'Report',
    components: {
		ChartOne,
        ChartTwo
  	},
    props: {
        dataSummary:{
            type: Array
        },
        dataTwenty:{
            type: Array
        },
        loadingData:{
            type: Boolean
        },
        type:{
            type: String
        },
        dateRange: {
            type: Array
        },
        filter: {
            type: String
        }
    },
    data() {
        return {
            ui_phone: false,
            pickerOptions: {
				disabledDate: this.disabledDate
			},
            dataTwentySummary: {},
            selectedFieldCompare: "waba",
            selectedTypeField:"conversation",
            input1: "",
            input2: "",
            filterChart2: 'phone',
            dataChart1: {
                loading: false,
				labels: [],
				datasets: [{
					label: '',
					data: [],
					fill: false,
                    borderColor: 'rgb(75, 192, 192)',
                    tension: 0.1
				},
                {
					label: '',
					data: [],
					fill: false,
                    borderColor: 'rgb(255, 99, 132)',
                    tension: 0.1
				}]
			},
            dataChart2: {
                loading: false,
				labels: [],
				datasets: [
                    {
                        label: '',
                        data: [],
                        fill: false,
                        borderColor: 'rgb(255, 99, 132)',
                        tension: 0.1
                    }
                ]
			},
            options: {
				scales: {
					y: {
						beginAtZero: true
					}
				},
				segmentShowStroke: false,
				responsive: true,
				legend: {
					onClick: function(event){
						// console.log(event)
					},
					position: 'bottom',
				},
				title: {
					display: true,
					text: 'Conversation'
				},
				animation: {
					animateScale: true,
					animateRotate: true
				},
				plugins: {
					labels: {
						// render 'label', 'value', 'percentage', 'image' or custom function, default is 'percentage'
						render: 'value',

						// font size, default is defaultFontSize
						fontSize: 12,

						// font color, can be color array for each data or function for dynamic color, default is defaultFontColor
						fontColor: '#ffff',

						// font style, default is defaultFontStyle
						fontStyle: 'normal',

						// font family, default is defaultFontFamily
						fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",

						// position to draw label, available value is 'default', 'border' and 'outside'
						// bar chart ignores this
						// default is 'default'
						position: 'default',

					}
				},
				hover: {
					onHover: function(e,i) {
					let el = document.getElementsByClassName("chartjs");
					el[0].style.cursor = i[0] ? "pointer" : "default";
					}
				},
				onClick : (event, item)=>{
				// console.log('item on bar chart',item[0]._index || null);
				let id = event.path[0].getAttribute('id')
                    // if (id == 'chart-1') {
                    //     this.detailChart(id,item[0]._index)
                    // }
				}
			},
            idDetail:'',
            modalDetail: false,
            valueDetail: {},
            dataDetail:[
                // {
                //     phone_number: '6281110555777',
                //     masking_name: 'Trial 9',
                //     waba_name: 'Trial 9',
                //     type: 'Meta',
                //     case: `BI (25%), UI (75%)`,
                //     session: 100,
                //     revenue: 378.54
                // },
                // {
                //     phone_number: '6281110555777',
                //     masking_name: 'Trial 9',
                //     waba_name: 'Trial 9',
                //     type: 'DKD',
                //     case: `BI (25%), UI (50%), CBP (25%)`,
                //     session: 100,
                //     revenue: 378.54
                // }
            ],
            loadingDetail: false,
            activeTab: 'index',
            loadingBtnInq: false,
            // asyncComponent: 'peity',
            selectedStartDate: [
                moment().subtract(1,"day").format("YYYY-MM-DD"),
                moment().subtract(1,"day").format("YYYY-MM-DD")
            ],
            selectedStartDate1: [
                moment().subtract(1,"day").format("YYYY-MM-DD"),
                moment().subtract(1,"day").format("YYYY-MM-DD")
            ],
            selectedStartDate2: [
                moment().subtract(1,"day").format("YYYY-MM-DD"),
                moment().subtract(1,"day").format("YYYY-MM-DD")
            ],
            searchStartDate: [
                moment().subtract(1,"day").hours(0).minutes(0).seconds(0).format(),
                moment().hours(0).minutes(0).seconds(0).format()
            ],
            selectedFilter: 'meta_conversation',
            searchNumber: '',
            searchField: '',
            searchTerm: '',
            // selectedEndDate: '',
            filterInput: '',
            number:[],
            currentPage: 1,
            loadingReportTable: false,
            filterBy: [
                { value: "meta_conversation", label: "Meta Conversation" },
                { value: "meta_revenue", label: "Meta Revenue" },
                { value: "meta_bi", label: "Meta BI" },
                { value: "meta_ui", label: "Meta UI" },
            ],
            filterByCompare: [
                { value: "phone", label: "Phone Compare" },
                { value: "date", label: "Date Compare" }
            ],
            searchFields: [
                { value: "all", label: "All Client" },
                { value: "priority", label: "Priority" }
            ],
            messageTypeField: [
                { value: "waba", label: "WABA" },
                { value: "phone_number", label: "Phone Number" },
            ],
            sessionTypeField: [
                { value: "all", label: "All" },
                { value: "charge", label: "Charge" },
                { value: "not_charge", label: "Not Charge" },
            ],
            typeField: [
                { value: "conversation", label: "Conversation" },
                { value: "ui", label: "User Initiate" },
                { value: "bi", label: "Business Initiate" },
                { value: "revenue", label: "Revenue" }
            ],
            selectedMessageTypeField: "waba",
            selectedSessionTypeField: "all",
            tableData: [
                // {
                //     no: '1',
                //     id: '305490440128441',
                //     name: 'Trial 9',
                //     type: 'Meta',
                //     case: `BI (25%), UI (75%)`,
                //     session: 100,
                //     revenue: 378.54
                // },
                // {
                //     no: '1',
                //     id: '305490440128441',
                //     name: 'Trial 9',
                //     type: 'DKD',
                //     case: `BI (25%), UI (50%), CBP (25%)`,
                //     session: 100,
                //     revenue: 378.54
                // }
            ],
            loadingExport: false,
            selectedYear: moment().format("YYYY"),
            //selectedMonth: moment().format("M"),
            selectedPhone: '',
            selectedField: 'all',
            dataMessages: [],
            totalMessages: 0,
            fbbmStatus: {
                sent: 0,
                delivered: 0
            },
            status: {
                read:0,
                sent:0,
                failed:0,
                delivered:0,
                invalid: 0,
            },
            usage: this.statusUsage
        }
    },
    methods: {
        disabledDate(date) {
			// console.log('date disable', date);
			var today = moment(), diff = today.diff(moment(date), 'd')
						if(diff < 1){
							return true
						} else {
							if(diff == 0){
								if(today.isSame(moment(date), 'd') == false){
									return true
								} else {
									return false
								}
							}
							return false
						}
				// return new Date() < date
		},
        handleChangeCompare(val){
            this.dataChart1.loading = true
            this.dataChart2.loading = true
            if (val == 'date') {
                this.dataChart1.datasets.splice(1,1)
            }
            else{
                this.dataChart1.datasets.push(
                    {
					label: '',
					data: [],
					fill: false,
                    borderColor: 'rgb(255, 99, 132)',
                    tension: 0.1
				})
            }

            setTimeout(() => {
                this.dataChart1.loading = false
                this.dataChart2.loading = false
            }, 200);

            // this.dataChart1.loading = false
            //     this.dataChart2.loading = false

        },
        tabClick(tab){
            console.log(tab);
        },
        async detailTopTwenty(val){
            this.valueDetail = val
            this.idDetail = val.id
            this.modalDetail = true
            await this.loadDetail(this.idDetail)
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (!this.ui_phone) {
                if (columnIndex < 3) {
                    if (rowIndex % 2 === 0) {
                    return {
                        rowspan: 2,
                        colspan: 1
                    };
                    } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                    }
                }
        
                if (columnIndex === 7) {
                    if (rowIndex % 2 === 0) {
                    return {
                        rowspan: 2,
                        colspan: 1
                    };
                    } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                    }
                }
            }
            else {
                if (columnIndex < 4) {
                    if (rowIndex % 2 === 0) {
                    return {
                        rowspan: 2,
                        colspan: 1
                    };
                    } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                    }
                }

                if (columnIndex === 8) {
                    if (rowIndex % 2 === 0) {
                    return {
                        rowspan: 2,
                        colspan: 1
                    };
                    } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                    }
                }
            }
            
      },
      objectSpanMethod2({ row, column, rowIndex, columnIndex }) {
            
        if (columnIndex < 4) {
            if (rowIndex % 2 === 0) {
            return {
                rowspan: 2,
                colspan: 1
            };
            } else {
            return {
                rowspan: 0,
                colspan: 0
            };
            }
        }

        if (columnIndex === 8) {
            if (rowIndex % 2 === 0) {
            return {
                rowspan: 2,
                colspan: 1
            };
            } else {
            return {
                rowspan: 0,
                colspan: 0
            };
            }
        }
      },
      objectSpanMethodDetail({ row, column, rowIndex, columnIndex }) {
        if (columnIndex < 2) {
            if (rowIndex % 2 === 0) {
            return {
                rowspan: 2,
                colspan: 1
            };
            } else {
            return {
                rowspan: 0,
                colspan: 0
            };
            }
        }
      },
      formatPrice(val){
			return new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", minimumFractionDigits: 0 }).format(val);
		},
        formatDate(val, format){
            return moment(val).local().format(format)
        },
        formatNumber(value) {
			// let val = (value/1).toFixed(2).replace('.', ',')
			return value.toLocaleString('id-ID')
		},
        async paginateReport(page) {
            this.currentPage = page
            await this.loadReport(this.currentPage, null, { search_by: this.searchField, search: this.searchTerm })
        },
        async downloadExcel(){
            this.loadingExport = true
            await this.loadReport(1, 'download', { search_by: this.searchField, search: this.searchTerm })
            this.loadingExport = false
        },
        // async loadWA() {
        //   // this.loadingNumber = true
        //   let custId = this.$route.params.consumen
        //   await api({
        //     method: 'post',
        //     url: config.baseApi +'user/'+custId+'/detail_number'
        //   }).then(result => {
        //     // console.log(result.data)
        //     this.number = result.data.data
        //     this.selectedPhone = this.number[0]
        //     this.loadReport()
        //   }).catch(error => {
        //     this.$swal(this.$t('error'), error.message, "error")
        //   })
        //   // this.loadingNumber = false
        // },
        async changeFilter() {
            if (this.selectedStartDate) {
				let today = moment(this.selectedStartDate[1]), diff = today.diff(moment(this.selectedStartDate[0]), 'd')
				if (diff > 30) {
					this.$swal(this.$t('info'), "Can't set filter date more than 30 days.", "info")
					return
				}
			}
            this.currentPage = 1
			this.loadReport(this.currentPage)
            await this.loadSummary()
		},
        changeFilterCompare() {
            // this.currentPage = 1
			this.loadCompare()
		},
        mergeNoDuplicates(...arrays) {
            let mergedArray = [];
    
            arrays.forEach(array => {
                mergedArray = [...mergedArray, ...array]
            });
    
            const mergedUnique = mergedArray
                .filter((item, index) => 
                    mergedArray.indexOf(item) === index);
            return mergedUnique;
        },
        async loadCompare(){

            if(this.filterChart2 == 'phone'){
                if (!this.selectedStartDate1 || !this.selectedStartDate1[0] || !this.selectedStartDate1[1] || !this.input1 || !this.input2) {
                    this.$message.error({
                        showClose: false,
                        message: 'All field filter is required'
                    });
                    return
                }
            }
            else{
                if (!this.selectedStartDate1 || !this.selectedStartDate1[0] || !this.selectedStartDate1[1] || !this.selectedStartDate2 || !this.selectedStartDate2[0] || !this.selectedStartDate2[1] || !this.input1 || !this.input2) {
                    this.$message.error({
                        showClose: false,
                        message: 'All field filter is required'
                    });
                    return
                }
            }

            let param = {
                    type: this.selectedTypeField,
                    filter: this.selectedFieldCompare,
                    compare: this.filterChart2,
                    "date1":this.selectedStartDate1,
                    param1: this.input1,
                    param2: this.input2
                }
            
            if (this.filterChart2 == 'date') {
                param.date2 = this.selectedStartDate2
            }
            else{
                param.date2 = this.selectedStartDate1
            }

            this.options.title.text = ''
            this.dataChart1.labels = []
            this.dataChart1.datasets = []
            this.dataChart2.labels = []
            this.dataChart2.datasets = []

            this.loadingReportTable = true
            this.dataChart1.loading = true
            this.dataChart2.loading = true
            let label = ''

            switch (this.selectedTypeField) {
                case 'conversation':
                    label = 'Conversation'
                    
                    break;
                case 'revenue':
                    label = 'Revenue'
                    
                    break;
                case 'ui':
                    label = 'User Initiate'
                    
                    break;
                case 'bi':
                    label = 'Business Initiate'
                    
                    break;
                default:
                    break;
            }

			let apiOptions = {
                url: config.baseApi+ "bussiness/get-top-twenty-compare",
                method: 'get',
                params: param
            }

            await api(apiOptions)
            .then(res => {
                    // var dt
                if(res.data.ec == 200){
                    
                    this.options.title.text = label
                    if (this.filterChart2 == 'date') {

                        this.dataChart1.labels = res.data.data.one.length > 0 ? res.data.data.one.map(el => moment(el.date).format("DD/MM/YYYY")) : []
                        this.dataChart1.datasets[0] = {
                            label: this.input1,
                            data: res.data.data.one.length > 0 ? res.data.data.one.map(el => parseInt(el.value)) : [],
                            fill: false,
                            borderColor: 'rgb(75, 192, 192)',
                            tension: 0.1
                        }

                        this.dataChart2.labels = res.data.data.two.length > 0 ? res.data.data.two.map(el => moment(el.date).format("DD/MM/YYYY")): []
                        this.dataChart2.datasets[0] = {
                            label: this.input2,
                            data: res.data.data.two.length > 0 ? res.data.data.two.map(el => parseInt(el.value)) : [],
                            fill: false,
                            borderColor: 'rgb(255, 99, 132)',
                            tension: 0.1
                        }

                    }
                    else {
                        let label1 = res.data.data.one.length > 0 ? res.data.data.one.map(el => el.date) : []
                        let label2 = res.data.data.two.length > 0 ? res.data.data.two.map(el => el.date): []
                        let labels = this.mergeNoDuplicates(label1,label2)
                        this.dataChart1.labels = labels
                        this.dataChart1.labels.sort((date1, date2) => moment(date1) - moment(date2))
                        this.dataChart1.labels = this.dataChart1.labels.length > 0 ? this.dataChart1.labels.map(el => moment(el).format("DD/MM/YYYY")):this.dataChart1.labels

                        this.dataChart1.datasets[0] = {
                            label:  this.input1,
                            data: this.dataChart1.labels.length > 0 ? labels.map(el => {
                                let found = res.data.data.one.find(v => v.date == el)
                                return (found ? parseInt(found.value) : 0)
                            }) : [],
                            fill: false,
                            borderColor: 'rgb(75, 192, 192)',
                            tension: 0.1
                        }

                        this.dataChart1.datasets[1] = {
                            label: this.input2,
                            data: this.dataChart1.labels.length > 0 ? labels.map(el => {
                                let found = res.data.data.two.find(v => v.date == el)
                                return (found ? parseInt(found.value) : 0)
                            }) : [],
                            fill: false,
                            borderColor: 'rgb(255, 99, 132)',
                            tension: 0.1
                        }
                    }

                }
                this.loadingReportTable = false
                this.dataChart1.loading = false
                this.dataChart2.loading = false
            })
            .catch(error => {
                this.loadingReportTable = false
				this.$swal(this.$t('error'), error.message, "error")
                this.dataChart1.loading = false
                this.dataChart2.loading = false
            })
            // this.loadingReportTable = false
        },
        async loadReport(page = 1){

            if (!this.selectedStartDate || !this.selectedStartDate[0] || !this.selectedStartDate[1] || !this.selectedMessageTypeField || !this.selectedFilter) {
                this.$message.error({
                    showClose: false,
                    message: 'All field filter is required'
                });
                return
            }

            this.loadingReportTable = true
			let custId = this.$route.params.consumen
			let apiOptions = {
                url: config.baseApi+ "bussiness/get-top-twenty",
                method: 'get',
                params: {
                    // page: page,
                    type: this.selectedMessageTypeField,
                    filter: this.selectedFilter,
                    "startDate":this.selectedStartDate[0],
                    "endDate":this.selectedStartDate[1],
                }
            }

            await api(apiOptions)
            .then(res => {
                    // var dt
                if(res.data.ec == 200){
                    
                    if (Array.isArray(res.data.data)) {
                        this.tableData = res.data.data
                    }
                    else{
                        this.tableData = res.data.data.data
                    }
                }

                if (this.selectedMessageTypeField == "phone_number") {
                    this.ui_phone = true    
                }

                if (this.selectedMessageTypeField != "phone_number") {
                    this.ui_phone = false    
                }

                this.loadingReportTable = false
            })
            .catch(error => {
                this.loadingReportTable = false
				this.$swal(this.$t('error'), error.message, "error")
            })
            // this.loadingReportTable = false
        },
        async loadDetail(id = null){

            if (!id) {
                this.$message.error({
                    showClose: false,
                    message: 'waba id not found !'
                });
                return
            }

            this.loadingDetail = true
			let apiOptions = {
                url: config.baseApi+ "bussiness/get-top-twenty-detail/" + id,
                method: 'get',
                params: {
                    "startDate":this.valueDetail.startDate,
                    "endDate":this.valueDetail.endDate,
                }
            }

            await api(apiOptions)
            .then(res => {
                    // var dt
                if(res.data.ec == 200){
                    if (Array.isArray(res.data.data)) {
                        this.dataDetail = res.data.data
                    }
                    else{
                        this.dataDetail = res.data.data.data
                    }
                        
                }
                else{
                    this.modalDetail = false
                    this.$swal(this.$t('error'), error.message, "error")
                }

                this.loadingDetail = false
            })
            .catch(error => {
                this.loadingDetail = false
                this.modalDetail = false
				this.$swal(this.$t('error'), error.message, "error")
            })
            // this.loadingDetail = false
        },
        async loadSummary(page = 1){
			if (!this.selectedStartDate || !this.selectedStartDate[0] || !this.selectedStartDate[1]) {
                this.$message.error({
                    showClose: false,
                    message: 'Field selected date is required'
                });
                return
            }
            this.loadingTemplate = true
			let apiOptions = {
                url: config.baseApi+ "bussiness/get-top-twenty-summary",
                method: 'get',
                params: {
                    // page: page,
                    type: this.selectedMessageTypeField,
                    filter: this.selectedFilter,
                    "startDate":this.selectedStartDate[0],
                    "endDate":this.selectedStartDate[1],
                }
            }

            await api(apiOptions)
            .then(res => {
                    // var dt
                if(res.data.ec == 200){
					this.dataTwentySummary = res.data.data
                    this.dataTwentySummary.meta_revenue = this.dataTwentySummary.meta_revenue ? Number(this.dataTwentySummary.meta_revenue) : 0
                    this.dataTwentySummary.dkd_revenue = this.dataTwentySummary.dkd_revenue ? Number(this.dataTwentySummary.dkd_revenue) : 0
                }

				this.loadingTemplate = false
            })
            .catch(error => {
				this.$swal(this.$t('error'), error.message, "error")
				this.loadingTemplate = false
            })
            
        }
    },
//    created() {
//         if (!this.loadingReport && !this.selectedPhone) {
//             this.loadWA()
//         }
//     },
    /* mounted() {
        // this.loadWA()
        let yearNow = new Date().getFullYear()
		let yearStart = new Date().getFullYear() - 2
		for(var i = yearNow; i >= yearStart; i--){
			this.optionsYear.push({ value: i, label: i })
		}
		// this.optionsYear = year
    }, */
    watch: {
        dataTwenty: function() {
            this.tableData = this.dataTwenty
        },
        dataSummary: function() {
            this.dataTwentySummary = this.dataSummary[0]
        },
        loadingData: function() {
            this.loadingReportTable = this.loadingData
        },
        type: function() {
            this.selectedMessageTypeField = this.type
        },
        dateRange: function() {
            this.selectedStartDate = this.dateRange
        },
        filter: function() {
            this.selectedFilter = this.filter           
        }
    }
}
</script>
